<template lang="html">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <!-- <img src="images/divider.png" alt="" width="100%"> -->
                <h2 class="text-center">Szeretne értesülni heti menükínálatunkról és eseményeinkről?<br>
                Iratkozzon fel hírlevelünkre!</h2>

                <h2>Hírlevél</h2>
                <div style="margin-left:20px;font-size:22px;margin-bottom:20px;">
                    <span style="font-weight:bold;">Név:</span>
                    <input v-model="name" type="text" style="width:500px;max-width:100%;border-radius:20px;border-color:black;outline:none;padding:10px;" />
                    <br><br>
                    <span style="font-weight:bold;">Cím:</span>
                    <input v-model="email" type="text" style="width:500px;max-width:100%;border-radius:20px;border-color:black;outline:none;padding:10px;" />
                    <br><br>
                    <span><router-link tag="i" to="/page/aszf" style="color:#C7212E; cursor:pointer">Adatkezelési tájékoztató >></router-link></span>
                    <br><span>Adatkezelési nyilvántartás száma: <b>NAIH-123456789</b></span>
                    <br><br>
                    <input v-model="aszf" style="transform: scale(1.5); margin-right:20px;" type="checkbox" /> <span style="font-weight:bold;">Az adatkezelési nyilatkozatban foglaltakat elfogadom, hozzájárulok, hogy a Bora Hotel Kft. a megadott személyes adataimat kezelje és rendszeres hírlevelet küldjön részemre.</span>
                    <br>
                    <br>
                    <button class="my-button"
                    style="background-image: url('images/aranysav.jpg');font-size:28px;width:300px;"
                     @click="send()">Feliratkozás</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Endpoints from '@commons/communication/endpoints.js';

export default {
    mixins:[Endpoints],
    data:function () {
        return {
            aszf:false,
            name:'',
            email:''
        };
    },
    methods:{
        send:function () {
            if (!this.email && !this.name){
                toastr.warning('Minden adat kitöltése kötelező')
                return;
            }
            if (!this.aszf){
                toastr.warning('Az ÁSZF elfogadása kötelező')
                return;
            }
            var self = this;
            this.connSubscribeToNewsletter(this.email,this.name,function (r) {
                toastr.success('Sikeres feliratkozás');
                self.email = ''
                self.name = ''
            })
        }
    }
}
</script>

<style lang="css">
.my-button{
    background-size: contain;
    color:black;
    text-transform: uppercase;
    font-size: 14pt;
    border-radius: 0px;
    padding: 8px 16px;
    font-weight: bold;
    width: 100%;
    border-radius: 8px;
    border:none;
    outline:none;
}
</style>



// WEBPACK FOOTER //
// NewsletterSub.vue?367cc492